import { Popup } from "antd-mobile";
import { useEffect, useMemo, useState } from "react";
import { ReactComponent as Logo } from "./assets/logo.svg";
import { ReactComponent as Close } from "@src/assets/CN/svg/close.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useNavList from "../../PCLayouts/Header/useNavList";
import { Collapse } from "antd-mobile";
import { ReactComponent as ChevronRight } from "@src/assets/CN/svg/chevron-right.svg";
import { ReactComponent as ChevronDown } from "@src/assets/CN/svg/chevron-down.svg";
import styles from "./index.module.less";
import _ from "lodash";
import i18n from "@src/Basic/Language/i18n";
import { IKVProps } from "@src/Model/IKVProps";

const NavList = (props: any) => {
  const { visible, handleVisible } = props;
  const { pathname, state } = useLocation();
  const navigator = useNavigate();
  const { lang } = useParams();
  const { navList } = useNavList();
  const [active, setActive] = useState<string>("");
  const [firstLevelNav, setFirstlevelNav] = useState<string>(""); // 一级nav
  const [secondLevelNav, setSecondLevelNav] = useState<string>(""); // 二级nav
  const navData = useMemo(() => {
    return navList?.filter((item) => !item.mobileHide);
  }, [navList]);

  const language = useMemo(() => {
    return lang || i18n.language;
  }, [lang, i18n.language]);

  const header = useMemo(() => {
    return (
      <div className={styles.navListHeader}>
        <Logo
          onClick={() => {
            handleVisible(false);
            navigator(`/${language}/home`);
          }}
        />
        <Close
          onClick={() => {
            handleVisible(false);
          }}
        />
      </div>
    );
  }, [lang]);
  const path = useMemo(() => {
    return pathname.replace(`/${language}`, "");
  }, [pathname]);

  useEffect(() => {
    const key = lang ? path.split("/")[1] : pathname.split("/")[2];
    console.log("firstLevelNav", _.find(navData, { key })?.key);
    setFirstlevelNav(_.find(navData, { key })?.key);
  }, [navData, path]);

  useEffect(() => {
    if (firstLevelNav === "product") {
      const content = _.find(navData, { key: firstLevelNav })?.content;
      if (content) {
        const _path = _.find(content, (o: IKVProps) => o.path === path)?.path;
        setSecondLevelNav(_path);
      }
    } else {
      setSecondLevelNav(
        _.find(_.find(navData, { key: firstLevelNav })?.mobileContent, { path })?.path
      );
    }
  }, [firstLevelNav, path]);

  const handleNavActive = (key: string) => {
    const nav = _.find(navData, { key });

    if (key && !nav?.content?.length) {
      if (nav.key === firstLevelNav) {
        return;
      }
      navigator(`/${language}${nav.path}`);
      handleVisible(false);
    } else if (!key || nav?.content?.length) {
      console.log(53);
      setActive(key);
    }
  };

  console.log("navData", navData);

  console.log("secondLevelNav", secondLevelNav, path);

  return (
    <Popup
      destroyOnClose
      position="left"
      visible={visible}
      onClose={() => {
        handleVisible(false);
      }}
      className={styles.mobileNavList}
      closeOnMaskClick={true}
    >
      <div>{header}</div>
      <div className={styles.collapseWrap}>
        <Collapse activeKey={active} accordion onChange={handleNavActive}>
          {navData?.map((nav: any) => {
            return (
              <Collapse.Panel
                key={nav.key}
                title={
                  <span
                    className={`${styles.firstLevelTitle} ${
                      nav.key === firstLevelNav ? styles.activeNav : ""
                    }`}
                  >
                    {nav.title}
                  </span>
                }
                arrowIcon={nav?.content?.length ? <ChevronRight /> : null}
              >
                {nav.key === "product" ? (
                  <>
                    {!!nav?.content?.length && (
                      <div className={styles.navContent}>
                        {nav?.content?.map((item: any, index: number) => {
                          return (
                            <div
                              className={`${styles.nav} ${
                                item.path === secondLevelNav ? styles.activeNav : ""
                              }`}
                              key={index}
                              onClick={() => {
                                if (item.path === secondLevelNav) {
                                  return;
                                }
                                navigator(`/${language}${item.path}`);
                                handleVisible(false);
                              }}
                            >
                              {item.title}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {!!nav?.mobileContent?.length && (
                      <div className={styles.navContent}>
                        {nav?.mobileContent?.map((item: any, index: number) => {
                          return (
                            <div
                              className={`${styles.nav} ${
                                item.path === secondLevelNav ? styles.activeNav : ""
                              }`}
                              key={index}
                              onClick={() => {
                                if (item.path === secondLevelNav) {
                                  return;
                                }
                                navigator(`/${language}${item.path}`);
                                handleVisible(false);
                              }}
                            >
                              {item.title}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </>
                )}
              </Collapse.Panel>
            );
          })}
        </Collapse>
        {/* <div className={styles.content}></div> */}
      </div>
    </Popup>
  );
};

export default NavList;
